import Header from "../../layout/header-3";
import Footer from "../../layout/footer";
import Link from "next/link";
import Pagination from "../../component/pagination";
import BlogItem from "../../element/BlogItem";
import { NextSeo } from "next-seo";

function BlogIndex({ posts }) {
  return (
    <>
      <NextSeo title="المقالات" canonical="https://esmart.sa/blog" />
      <Header />
      <div className="page-content bg-white">
        <div
          className="dlab-bnr-inr overlay-primary-dark"
          style={{ backgroundImage: "url(/images/banner/bnr1.jpg)" }}
        >
          <div className="container">
            <div className="dlab-bnr-inr-entry">
              <h1>المقالات</h1>
              <nav aria-label="breadcrumb" className="breadcrumb-row">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link legacyBehavior href="/">
                      <a>الرئيسية</a>
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    المقالات
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <section
          className="content-inner bg-img-fix"
          style={{ backgroundImage: "url(/images/background/bg1.png)" }}
        >
          <div className="container">
            <div className="row m-b50">
              <div className="row">
                {posts.data.map((post) => (
                  <BlogItem key={post.id} post={post} />
                ))}
              </div>
              <Pagination data={posts.meta} />
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
}

export async function getServerSideProps(context) {
  const page = context.query.page ? context.query.page : "";
  const category_id = context.query.category_id
    ? context.query.category_id
    : "";

  const res = await fetch(
    "https://backend.esmart.sa/api/articles?page=" +
      page +
      "&category_id=" +
      category_id,
    { headers: { "User-Agent": "eSmartWebSite" } }
  );
  if (!res.ok) {
    return {
      redirect: {
        destination: `/500`,
        permanent: false,
      },
    };
  }
  const posts = await res.json();
  return {
    props: {
      posts,
    },
  };
}

export default BlogIndex;
